// 官网域名：hotel.xinjingtech.net
// 管理平台域名：cloud.hotel.xinjingtech.net
// 内部管理后台： hotel.internal.xinjngtech.com
// 后台预发布环境：pre.xinjngtech.com
// 内部后台预发布环境：pre.internal.xinjngtech.com
// 测试官网域名：test.xinjngtech.com

let base;
let domain = window.location.host;
let hotelType = domain.indexOf('localhost') !== -1
switch (domain) {
  case 'xinjingtech.net':
    base = 'https://xinjingtech.net/' // 正式官网
    break;
  case 'cloud.hotel.xinjingtech.net': // 正式酒店
    base = 'https://cloud.hotel.xinjingtech.net/'
    break;
  case 'pre.xinjngtech.com': //  酒店预发布环境      
    base = 'https://pre.xinjngtech.com/'
    break;
  case 'test.website.xinjngtech.com':
    base = 'https://test.website.xinjngtech.com/' // 测试官网
    break;
  case 'test.xinjngtech.com': // 测试酒店
    base = 'https://test.xinjngtech.com/'
    break;
  case 'dev.xinjngtech.com': //  酒店本地环境   
    base = 'https://dev.xinjngtech.com/'
    break;
  default:
    if (hotelType) {
      console.log(hotelType, 'url--------')
      base = 'https://test.xinjngtech.com/'
      //  base = 'https://dev.xinjngtech.com/'
    } else {
      base = window.location.protocol + '//' + (process.env.NODE_API_DOMAIN || window.location.host) + '/';
    }
    break;
}
export default base;



// WEBPACK FOOTER //
// ./src/api/baseUrl.js